@if (survey) {
  <div class="container single-view" id="take-survey">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" [routerLink]="['/surveys/' + surveyId]"
          class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SURVEYS.BTN_BACK_TO_SURVEY' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
          <div class="title-wr">
            <h1 class="section-title">{{ survey.name }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          @if (survey && !loading && isSurveyAvailable && visibleQuestions.length === 0) {
            <div class="survey-empty-language-message p-4 border border-round text-center" data-testid="survey-no-questions-language-message">
              <p class="text-lg font-semibold mb-2">{{ 'TAKE_SURVEY.NO_QUESTIONS_FOR_SELECTED_LANGUAGE_TITLE' | translate }}</p>
              <p class="text-base">{{ 'TAKE_SURVEY.NO_QUESTIONS_FOR_SELECTED_LANGUAGE_MESSAGE' | translate }}</p>
            </div>
          }
          @if (survey && isSurveyAvailable && surveyQuestionsForm && visibleQuestions.length > 0 && questionsFormArray.length === visibleQuestions.length) {
            <form [formGroup]="surveyQuestionsForm">
              <div class="survey-wr" formArrayName="questions">
                @for (question of visibleQuestions; track question; let i = $index) {
                  <div class="survey-question-card mb-5 p-4 border border-round" [formGroupName]="i" [attr.data-testid]="'question-card-' + question.id">
                    <div class="mb-3 question-title">
                      <p class="text-lg font-semibold">{{ getQuestionTranslation(question) }}</p>
                    </div>
                    <!-- FIXED VALUES -->
                    @if (question.questionType === questionType.FixedValues) {
                      <!-- RADIO BUTTONS -->
                      @if (!question.allowsMultipleAnswers) {
                        <div class="flex flex-column gap-3" [attr.data-testid]="'question-radio-group-' + question.id">
                          @for (option of question.answerOptions; track option) {
                            <div class="flex align-items-center gap-2" [attr.data-testid]="'question-' + question.id + '-option-wrapper-' + option.id">
                              <p-radioButton [inputId]="'question-' + question.id + '-option-' + option.id" [name]="getAnswerControlName(question.id)" [formControlName]="getAnswerControlName(question.id)" [value]="option.id" [attr.data-testid]="'question-' + question.id + '-radio-' + option.id">
                              </p-radioButton>
                              <label [for]="'question-' + question.id + '-option-' + option.id" [attr.data-testid]="'question-' + question.id + '-label-' + option.id">{{ getAnswerTranslation(option) }}</label>
                            </div>
                          }
                        </div>
                      }
                      <!-- CHECKBOXES -->
                      @if (question.allowsMultipleAnswers) {
                        <div formArrayName="answers" class="flex flex-column gap-3" [attr.data-testid]="'question-checkbox-group-' + question.id">
                          @for (option of question.answerOptions; track option; let optionIndex = $index) {
                            <div class="flex align-items-center gap-2" [attr.data-testid]="'question-' + question.id + '-option-wrapper-' + option.id">
                              <p-checkbox [binary]="true" [formControlName]="optionIndex" [inputId]="'question-' + question.id + '-option-' + option.id" [attr.data-testid]="'question-' + question.id + '-checkbox-' + option.id" />
                              <label [for]="'question-' + question.id + '-option-' + option.id" [attr.data-testid]="'question-' + question.id + '-label-' + option.id">{{ getAnswerTranslation(option) }}</label>
                            </div>
                          }
                        </div>
                      }
                    }
                    <!-- TEXT -->
                    @if (question.questionType === questionType.Text) {
                      <textarea rows="5" class="w-full" [formControlName]="getAnswerControlName(question.id)" [attr.data-testid]="'question-' + question.id + '-textarea'">
                      </textarea>
                    }
                    <!-- NUMBER -->
                    @if (question.questionType === questionType.Number) {
                      <input type="number" class="w-full" [formControlName]="getAnswerControlName(question.id)" [attr.data-testid]="'question-' + question.id + '-number-input'">
                    }
                  </div>
                }
              </div>
              <div class="flex justify-content-end mt-4">
                <button type="submit" class="btn primary-btn" [disabled]="submittingForm" (click)="submitForm()">{{ 'TAKE_SURVEY.SUBMIT_SURVEY' | translate }}</button>
              </div>
            </form>
          }
          <!-- Survey not available -->
          @if (survey && !loading && !isSurveyAvailable) {
            <div class="survey-unavailable-message p-4 border border-round text-center" data-testid="survey-unavailable-message">
              <p class="text-lg font-semibold mb-2">{{ 'TAKE_SURVEY.SURVEY_NOT_AVAILABLE_TITLE' | translate }}</p>
              <p class="text-base mb-4">{{ 'TAKE_SURVEY.SURVEY_NOT_AVAILABLE_MESSAGE' | translate }}</p>
              <button type="button" class="btn primary-btn" routerLink="/surveys" data-testid="back-to-surveys-btn">{{ 'SURVEYS.BTN_BACK_TO_SURVEYS' | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
